import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["Left", "Right", "Button", "IconButton"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '@rexlabs/box';
import { StyleSheet, StylesProvider, useStyles, border } from '@rexlabs/styling';
var LEFT = {
  Button: StyleSheet({
    container: _objectSpread({}, border.styles({
      target: 'button.split.left',
      right: {
        radius: 'none',
        width: 'none'
      }
    }))
  })
};
var RIGHT = {
  Button: StyleSheet({
    container: _objectSpread({}, border.styles({
      target: 'button.split.right',
      left: {
        radius: 'none',
        width: 'none'
      }
    }))
  })
};
var defaultStyles = StyleSheet({
  divider: {
    display: 'flex',
    alignSelf: 'stretch',
    zIndex: 0,
    // height: ({ token }) => token('button.height', '4rem'),
    width: function width(_ref) {
      var token = _ref.token;
      return token('button.split.divider.width', '0.1rem');
    },
    backgroundColor: function backgroundColor(_ref2) {
      var token = _ref2.token;
      return token('button.split.divider.background.color', token('color.container.static.default'));
    }
  }
});

function SplitButton(_ref3) {
  var Left = _ref3.Left,
      Right = _ref3.Right,
      Button = _ref3.Button,
      IconButton = _ref3.IconButton,
      props = _objectWithoutProperties(_ref3, _excluded);

  var s = useStyles(defaultStyles, 'SplitButton');
  return /*#__PURE__*/React.createElement(Box, _extends({
    flexDirection: "row",
    alignItems: "center"
  }, props), /*#__PURE__*/React.createElement(StylesProvider, {
    components: LEFT
  }, /*#__PURE__*/React.createElement(Left, {
    Button: Button,
    IconButton: IconButton
  })), /*#__PURE__*/React.createElement(Box, s('divider')), /*#__PURE__*/React.createElement(StylesProvider, {
    components: RIGHT
  }, /*#__PURE__*/React.createElement(Right, {
    Button: Button,
    IconButton: IconButton
  })));
}

export default SplitButton;